module.exports = __webpack_public_path__ + "static/img/4d1f05321f4d54505ce18a19c54f193e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode2-show-2.png
// module id = V//V
// module chunks = 1